import React, { useState } from "react";
import {
  FaChevronDown,
  FaFacebookF,
  FaInstagram,
  FaXTwitter,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa6";
import { Link } from "react-router-dom";
import logo from "../assets/images/songstarklogo.png";
import momologo from "../assets/images/momo icon.png";
import visa from "../assets/images/visa.png";
import mastercard from "../assets/images/mastercard.png";
// import paypal from '../assets/images/paypal.png';
import dhl from "../assets/images/dhllogo.png";
import "../styles/Footer.css";
import { useSelector } from "react-redux";

function Footer() {
  const { settings } = useSelector((state) => state.site);
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="footer-container">
      <div className="footer">
        <div
          className={`footer-section ${
            openSection === "account" ? "active" : ""
          }`}
        >
          <h3 onClick={() => toggleSection("account")}>
            MY ACCOUNT
            <FaChevronDown className="chevron-icon" />
          </h3>
          <div className="footer-content">
            <p>
              <Link to="/orders">Track orders</Link>
            </p>
            <p>
              <Link to="/myaccount">Wishlist</Link>
            </p>
            <p>
              <Link to="/contactus">Contact us</Link>
            </p>
          </div>
        </div>

        <div
          className={`footer-section ${
            openSection === "about" ? "active" : ""
          }`}
        >
          <h3 onClick={() => toggleSection("about")}>
            ABOUT US
            <FaChevronDown className="chevron-icon" />
          </h3>
          <div className="footer-content">
            <p>
              K-Shop brings you quality lifestyle and sports products sourced
              from across Asia.
            </p>
            <p>
              We focus on authentic goods, fair pricing, and a smooth shopping
              experience from discovery to delivery.
            </p>
          </div>
        </div>

        <div
          className={`footer-section ${openSection === "help" ? "active" : ""}`}
        >
          <h3 onClick={() => toggleSection("help")}>
            HELP
            <FaChevronDown className="chevron-icon" />
          </h3>
          <div className="footer-content">
            <p>
              <Link to="/contactus">Customer service</Link>
            </p>
            <p>
              <Link to="/faqs">FAQS</Link>
            </p>
          </div>
        </div>

        <div
          className={`footer-section ${
            openSection === "terms" ? "active" : ""
          }`}
        >
          <h3 onClick={() => toggleSection("terms")}>
            TERMS & POLICIES
            <FaChevronDown className="chevron-icon" />
          </h3>
          <div className="footer-content">
            <p>
              <Link to="/terms">Terms & Conditions</Link>
            </p>
            <p>
              <Link to="/legal">Legal notices</Link>
            </p>
            <p>
              <Link to="/privacy">Privacy policy</Link>
            </p>
          </div>
        </div>
      </div>

      <div className="business-info">
        <div className="company-details">
          <img src={logo} alt="Song & Stark Cooperation Rwanda Ltd." />
          <h3>
            Song & Stark Cooperation <br /> Rwanda Ltd.
          </h3>
        </div>
        <div className="company-info">
          <p>CEO: WAN SONG</p>
          <p>Company Code: 121143548</p>
          <p>Address: {settings.address}</p>
          <p>E-mail: {settings.email}</p>
          <a
            href="https://rwanda.songstark.com/"
            target="_blank"
            rel="noreferrer"
            className="info-link"
          >
            Click here for business information
          </a>
        </div>

        <div className="payment-delivery">
          <div className="social-media">
            <a href={settings.facebook} target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href={settings.instagram} target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href={settings.twitter} target="_blank" rel="noreferrer">
              <FaXTwitter />
            </a>
            <a href={settings.tiktok} target="_blank" rel="noreferrer">
              <FaTiktok />
            </a>
            <a href={settings.youtube} target="_blank" rel="noreferrer">
              <FaYoutube />
            </a>
          </div>
          <h4>Payment Methods</h4>
          {/* <img src={paypal} alt="Paypal" /> */}
          <img src={momologo} alt="MOMO" />
          <img src={visa} alt="VISA" />
          <img src={mastercard} alt="Mastercard" />
          <div className="delivery-method">
            <h4>Delivery Methods</h4>
            <img src={dhl} alt="DHL" />
            {/* Add delivery methods */}
          </div>
        </div>
      </div>
      <p className="copyright">
        © 2023 Song & Stark Cooperation Rwanda Ltd. All Rights Reserved.
      </p>
    </div>
  );
}

export default Footer;
